<template>
    <div class="edit_shop">
        <div class="panel">
            <p>{{itemName}}</p>
            <p>库存数量：{{count}}</p>
        </div>
        <div class="edit_info">
            <ul class="ul">
                <li class="li head">
                    <p class="attribute">规格描述</p>
                    <p class="stock">库存数量</p>
                    <p class="add">操作</p>
                </li>
                <li class="li" v-for="(item,index) in dataList" :key="index">
                    <p>{{item.attributeValue}}</p>
                    <p>{{item.stock}}</p>
                    <p><van-stepper :min='0' v-model="item.stock" @plus="addCount(item.id,'add')" @minus="addCount(item.id,'del')"/></p>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import http from '@/utils/axios'
export default {
    data(){
        return{
            count:0,
            itemName:'',
            dataList:[]
        }
    },
    methods:{
        getShopInfo(){
             this.itemName = this.$route.params.itemName;
             
            http({
                url:'/item/item/quick/bess/goodInfo/'+this.$route.params.id,
                methods:'get'
            }).then(rps=>{
                if(rps.code===200){
                    rps.data.forEach(element => {
                        this.count += element.stock
                    });
                    this.dataList = rps.data;
                }
            })
        },
        addCount(id,type){
            let parmes={
                id:id,
            }
            if(type ==='add'){
                parmes.addStock=1
            }else{
                parmes.reduceStock=1
            }
            http({
                url:'item/item/quick/bess/updateStock',
                method:'post',
                parmes:parmes
            }).then(rps=>{
                console.log()
            })
        },
    },
    created(){
        // this.itemName = this.$route.params.itemName;
        // console.log(this.$route)
        this.getShopInfo();
        this.$loading.hide();
    }
}
</script>
<style lang="less" scoped>
    .edit_shop{
        background: #fff;
        // padding:  0 20px;
        .panel{
            padding: 20px;
            border-bottom:20px solid #f2f2f2;
            p{
                font-size: 28px;
                font-weight: 500;
                &:last-child{
                    padding: 10px 0;
                    font-size: 24px;
                    font-weight: 400;
                }
            }
        }
        .edit_info{
            .li{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 10px 20px;
                font-size: 28px; 
                p{
                    width: calc( 100% /3 );
                    text-align: center;
                }
            }
            
            .head{
                // background: #f2f2f2;
            }
        }

    }
</style>